
import { useNavigate, useLocation } from 'react-router-dom';
import { Shield, Bot, LayoutDashboard, Settings } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const AdminBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin } = useAuth();
  
  // For debugging - add console log to check admin status
  console.log('Admin status in bottom nav:', isAdmin);
  
  // If not admin, don't render the component
  if (!isAdmin) return null;
  
  // Function to determine if a route is active
  const isActive = (path: string) => location.pathname === path;
  
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-t border-gray-800 py-2 px-2">
      <div className="flex justify-around items-center">
        <button 
          onClick={() => navigate('/')}
          className={`flex flex-col items-center justify-center p-2 ${
            isActive('/') ? 'text-white' : 'text-gray-400 hover:text-white'
          }`}
        >
          <LayoutDashboard className="h-6 w-6 mb-1" />
          <span className="text-xs">Home</span>
        </button>
        
        <button 
          onClick={() => navigate('/admin-panel')}
          className={`flex flex-col items-center justify-center p-2 ${
            isActive('/admin-panel') ? 'text-orange-400' : 'text-orange-500 hover:text-orange-400'
          }`}
        >
          <Shield className="h-6 w-6 mb-1" />
          <span className="text-xs">Admin</span>
        </button>
        
        <button 
          onClick={() => navigate('/admin-ai-helper')}
          className={`flex flex-col items-center justify-center p-2 ${
            isActive('/admin-ai-helper') ? 'text-purple-400' : 'text-purple-500 hover:text-purple-400'
          }`}
        >
          <Bot className="h-6 w-6 mb-1" />
          <span className="text-xs">Jasmin</span>
        </button>
        
        <button 
          onClick={() => navigate('/settings')}
          className={`flex flex-col items-center justify-center p-2 ${
            isActive('/settings') ? 'text-white' : 'text-gray-400 hover:text-white'
          }`}
        >
          <Settings className="h-6 w-6 mb-1" />
          <span className="text-xs">Settings</span>
        </button>
      </div>
    </div>
  );
};

export default AdminBottomNav;
